// Make a simple headerless table where each entry is an array with 2 elements
import {type StyleObject, type UIChild, UI} from "../../stem-core/ui/UIBase";
import {SimpleTable} from "../ui/SimpleTable";
import type {ColumnOptions} from "../../stem-core/base/ColumnHandler";

export function MakeSimpleSummaryTable(entries: UIChild[][], nameCellStyle: StyleObject = {}, valueCellStyle: StyleObject = {textAlign: "right", fontWeight: 700}, tableStyle: StyleObject = {maxWidth: 712, padding: "12px 0px"}) {
    const columns: ColumnOptions<UIChild[]>[] = [
        {
            value: entry => entry[0],
            cellStyle: nameCellStyle,
        },
        {
            value: entry => entry[1],
            cellStyle: valueCellStyle,
        },
    ];

    return <SimpleTable
        entries={entries}
        columns={columns}
        noHeader
        style={tableStyle}
    />;
}
